var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 18.3337C4.55765 18.3337 4.13372 18.1581 3.82116 17.8455C3.5086 17.5329 3.33301 17.109 3.33301 16.667V3.33366C3.33301 2.89163 3.5086 2.46771 3.82116 2.15515C4.13372 1.84259 4.55765 1.66699 4.99967 1.66699H11.6663C11.9301 1.66657 12.1914 1.71833 12.4351 1.8193C12.6788 1.92027 12.9001 2.06846 13.0863 2.25533L16.0763 5.24533C16.2637 5.43158 16.4123 5.65312 16.5136 5.89713C16.6149 6.14114 16.6668 6.4028 16.6663 6.66699V16.667C16.6663 17.109 16.4907 17.5329 16.1782 17.8455C15.8656 18.1581 15.4417 18.3337 14.9997 18.3337H4.99967Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 1.66699V5.83366C11.667 6.05467 11.7548 6.26663 11.9111 6.42291C12.0674 6.57919 12.2793 6.66699 12.5003 6.66699H16.667",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 7.5H6.66699",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 10.833H6.66699",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 14.167H6.66699",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveLeaderboard);
export default __webpack_public_path__ + "static/media/ic_active_leaderboard.2d649bc7869f8bab447b23fa413dea0c.svg";
export { ForwardRef as ReactComponent };